
export default function useRequiredFieldsFilled(values) {
  if (!values) {
    return false;
  }
  return true;
};
